/* ============================================================
   MÁSTRONG · comportamiento de la landing
   Implementado con custom elements: cada componente se inicializa
   solo al conectarse al DOM y limpia sus listeners al desconectarse.
   Esto hace que recargar o reordenar una sección en el editor de
   temas NO duplique manejadores ni deje listeners huérfanos.
   ============================================================ */
(function () {
  'use strict';
  if (window.MastrongLoaded) return;
  window.MastrongLoaded = true;

  var def = function (name, ctor) {
    if (!window.customElements || customElements.get(name)) return;
    customElements.define(name, ctor);
  };
  var prefersReduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
  var $ = function (el, sel) { return el.querySelector(sel); };
  var $$ = function (el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); };

  /* ---------------- Base con gestión de listeners ---------------- */
  class MsBase extends HTMLElement {
    on(target, type, fn, opts) {
      this._subs = this._subs || [];
      target.addEventListener(type, fn, opts);
      this._subs.push([target, type, fn, opts]);
    }
    offAll() {
      (this._subs || []).forEach(function (s) { s[0].removeEventListener(s[1], s[2], s[3]); });
      this._subs = [];
    }
    disconnectedCallback() {
      this.offAll();
      if (this.teardown) this.teardown();
    }
  }

  /* ---------------- Galería del hero ---------------- */
  def('mastrong-gallery', class extends MsBase {
    connectedCallback() {
      this.slides = $$(this, '[data-ms-slide]');
      this.thumbs = $$(this, '[data-ms-thumb]');
      if (!this.slides.length) return;
      var self = this;
      this.index = 0;
      this.thumbs.forEach(function (t, i) {
        self.on(t, 'click', function () { self.go(i); });
      });
      var prev = $(this, '[data-ms-prev]');
      var next = $(this, '[data-ms-next]');
      if (prev) this.on(prev, 'click', function () { self.go(self.index - 1); });
      if (next) this.on(next, 'click', function () { self.go(self.index + 1); });
      this.on(this, 'keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
      });
      this.go(0);
    }
    go(i) {
      var n = this.slides.length;
      if (!n) return;
      this.index = ((i % n) + n) % n;
      var self = this;
      this.slides.forEach(function (s, k) {
        if (k === self.index) { s.setAttribute('data-active', ''); s.removeAttribute('aria-hidden'); }
        else { s.removeAttribute('data-active'); s.setAttribute('aria-hidden', 'true'); }
      });
      this.thumbs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === self.index ? 'true' : 'false');
      });
      var live = $(this, '[data-ms-gallery-status]');
      if (live) live.textContent = 'Imagen ' + (this.index + 1) + ' de ' + n;
    }
  });

  /* ---------------- Pestañas accesibles ---------------- */
  def('mastrong-tabs', class extends MsBase {
    connectedCallback() {
      this.tabs = $$(this, '[role="tab"]');
      this.panels = $$(this, '[role="tabpanel"]');
      if (!this.tabs.length) return;
      var self = this;
      this.tabs.forEach(function (t, i) {
        self.on(t, 'click', function () { self.select(i, true); });
        self.on(t, 'keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          self.select((i + d + self.tabs.length) % self.tabs.length, true);
        });
      });
      var start = this.tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      this.select(start < 0 ? 0 : start, false);
    }
    select(i, focus) {
      this.tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      this.panels.forEach(function (p, k) { p.hidden = k !== i; });
      this._i = i;
    }
    selectByPanelId(id) {
      var k = this.panels.findIndex(function (p) { return p.id === id; });
      if (k >= 0) this.select(k, false);
    }
  });

  /* ---------------- Acordeón ---------------- */
  def('mastrong-accordion', class extends MsBase {
    connectedCallback() {
      var self = this;
      this.single = this.getAttribute('data-single') === 'true';
      this.items = $$(this, '[data-ms-acc-btn]');
      this.items.forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        self.on(btn, 'click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (self.single && !open) self.closeAll();
          self.set(btn, panel, !open);
        });
      });
    }
    set(btn, panel, open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      var sign = $(btn, '[data-ms-sign]');
      if (sign) sign.textContent = open ? '−' : '+';
    }
    closeAll() {
      var self = this;
      this.items.forEach(function (b) {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) self.set(b, p, false);
      });
    }
    openById(panelId) {
      var btn = this.items.find(function (b) { return b.getAttribute('aria-controls') === panelId; });
      var p = document.getElementById(panelId);
      if (btn && p) { if (this.single) this.closeAll(); this.set(btn, p, true); }
    }
  });

  /* ---------------- Mostrar / ocultar texto ampliado ---------------- */
  def('mastrong-expand', class extends MsBase {
    connectedCallback() {
      var btn = $(this, '[data-ms-expand-btn]');
      var panel = $(this, '[data-ms-expand-panel]');
      if (!btn || !panel) return;
      var more = btn.getAttribute('data-more') || 'Leer más';
      var less = btn.getAttribute('data-less') || 'Leer menos';
      this.on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        btn.textContent = open ? more : less;
      });
    }
  });

  /* ---------------- Menú móvil ---------------- */
  def('mastrong-menu', class extends MsBase {
    connectedCallback() {
      var self = this;
      var btn = $(this, '[data-ms-menu-btn]');
      var panel = $(this, '[data-ms-menu-panel]');
      if (!btn || !panel) return;
      this.on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
      $$(panel, 'a').forEach(function (a) {
        self.on(a, 'click', function () {
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        });
      });
      this.on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) {
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          btn.focus();
        }
      });
    }
  });

  /* ---------------- Modal accesible ---------------- */
  def('mastrong-modal', class extends MsBase {
    connectedCallback() {
      var self = this;
      this.box = $(this, '[data-ms-modal-box]');
      this.on(this, 'click', function (e) { if (e.target === self) self.close(); });
      $$(this, '[data-ms-modal-close]').forEach(function (b) {
        self.on(b, 'click', function () { self.close(); });
      });
      this.on(document, 'keydown', function (e) {
        if (self.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); self.close(); }
        if (e.key === 'Tab') self.trap(e);
      });
      this.on(document, 'click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-ms-modal-open]') : null;
        if (t && t.getAttribute('data-ms-modal-open') === self.id) { e.preventDefault(); self.open(t); }
      });
      this.hidden = true;
    }
    focusables() {
      return $$(this, 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')
        .filter(function (el) { return el.offsetParent !== null; });
    }
    trap(e) {
      var f = this.focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    open(trigger) {
      this._return = trigger || document.activeElement;
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var f = this.focusables();
      if (f[0]) f[0].focus();
    }
    close() {
      this.hidden = true;
      document.documentElement.style.overflow = '';
      if (this._return && this._return.focus) this._return.focus();
    }
    teardown() { document.documentElement.style.overflow = ''; }
  });

  /* ---------------- Carrusel horizontal ---------------- */
  def('mastrong-carousel', class extends MsBase {
    connectedCallback() {
      var self = this;
      this.track = $(this, '[data-ms-track]');
      if (!this.track) return;
      this.prev = $(this, '[data-ms-prev]');
      this.next = $(this, '[data-ms-next]');
      if (this.prev) this.on(this.prev, 'click', function () { self.move(-1); });
      if (this.next) this.on(this.next, 'click', function () { self.move(1); });
      var sync = function () { self.sync(); };
      this.on(this.track, 'scroll', sync, { passive: true });
      this.on(window, 'resize', sync);
      this.sync();
    }
    move(dir) {
      var el = this.track;
      el.scrollTo({ left: el.scrollLeft + dir * el.clientWidth * 0.8, behavior: prefersReduced() ? 'auto' : 'smooth' });
    }
    sync() {
      var el = this.track;
      var max = el.scrollWidth - el.clientWidth;
      if (this.prev) this.prev.disabled = el.scrollLeft <= 2;
      if (this.next) this.next.disabled = el.scrollLeft >= max - 2;
    }
  });

  /* ---------------- Rotador de diapositivas (especialistas) ---------------- */
  def('mastrong-slider', class extends MsBase {
    connectedCallback() {
      var self = this;
      this.slides = $$(this, '[data-ms-slide]');
      if (!this.slides.length) return;
      this.i = 0;
      var prev = $(this, '[data-ms-prev]');
      var next = $(this, '[data-ms-next]');
      if (prev) this.on(prev, 'click', function () { self.go(self.i - 1); });
      if (next) this.on(next, 'click', function () { self.go(self.i + 1); });
      this.counter = $(this, '[data-ms-count]');
      this.go(0);
    }
    go(i) {
      var n = this.slides.length;
      if (!n) return;
      this.i = ((i % n) + n) % n;
      var self = this;
      this.slides.forEach(function (s, k) { s.hidden = k !== self.i; });
      if (this.counter) this.counter.textContent = (this.i + 1) + ' / ' + n;
    }
  });

  /* ---------------- Barra de compra fija ---------------- */
  def('mastrong-sticky', class extends MsBase {
    connectedCallback() {
      var self = this;
      this.threshold = parseInt(this.getAttribute('data-threshold') || '520', 10);
      // El espaciador hermano reserva el alto de la barra: así la barra
      // nunca tapa el pie ni los avisos legales, y no hace falta tocar
      // el padding del <body> del tema.
      this.spacer = this.previousElementSibling;
      if (!this.spacer || !this.spacer.classList.contains('ms-sticky-spacer')) this.spacer = null;
      var update = function () {
        var on = window.scrollY > self.threshold;
        if (on) self.setAttribute('data-visible', '');
        else self.removeAttribute('data-visible');
        // 8 px extra para que el contenido no quede pegado a la barra.
        var h = on ? (self.offsetHeight + 8) + 'px' : '0px';
        if (self.spacer) self.spacer.style.height = h;
        document.documentElement.style.setProperty('--ms-sticky-pad', h);
      };
      this.on(window, 'scroll', update, { passive: true });
      this.on(window, 'resize', update);
      update();
    }
    teardown() {
      if (this.spacer) this.spacer.style.height = '0px';
      document.documentElement.style.setProperty('--ms-sticky-pad', '0px');
    }
  });

  /* ---------------- Desplazamiento suave a un ancla ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-ms-scroll]') : null;
    if (!a) return;
    var id = a.getAttribute('data-ms-scroll');
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
    var f = target.querySelector('a[href],button:not([disabled]),input,select');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, prefersReduced() ? 0 : 450);
  });

  /* ---------------- Integración con el editor de temas ---------------- */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    var tabs = el.closest('mastrong-tabs');
    if (tabs && tabs.selectByPanelId) {
      var panel = el.getAttribute('role') === 'tabpanel' ? el : el.querySelector('[role="tabpanel"]');
      if (panel) tabs.selectByPanelId(panel.id);
    }

    var acc = el.closest('mastrong-accordion');
    if (acc && acc.openById) {
      var accBtn = el.matches('[data-ms-acc-btn]') ? el : el.querySelector('[data-ms-acc-btn]');
      if (accBtn) acc.openById(accBtn.getAttribute('aria-controls'));
    }

    var slider = el.closest('mastrong-slider');
    if (slider && slider.slides) {
      var s = el.matches('[data-ms-slide]') ? el : el.closest('[data-ms-slide]');
      var k = slider.slides.indexOf(s);
      if (k >= 0) slider.go(k);
    }

    var gal = el.closest('mastrong-gallery');
    if (gal && gal.slides) {
      var gs = el.matches('[data-ms-slide]') ? el : el.closest('[data-ms-slide]');
      var g = gal.slides.indexOf(gs);
      if (g >= 0) gal.go(g);
    }
  });
})();
